import { Helmet } from "react-helmet-async";

interface MetaProps {
  title?: string;
  description?: string;
  keywords?: string;
}

export default function Meta({
  title = "",
  description = "",
  keywords = "",
}: MetaProps) {

  



  return (
    <Helmet>
      <title>{title}</title>

      {description && <meta name="description" content={description} />}

      {keywords && <meta name="keywords" content={keywords} />}

    </Helmet>
  );
}
